import OptionAPI from '@/api/OptionAPI.js';
import httpClient from '@/api/axios-httpclient';

export default {
	loadOptions: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: OptionAPI.getAPIUrl() + '/getall',
				params: payload
			},
			true
		);

		if (res.Success) {
			context.commit('updateOptionsData', res.Data);
			return res.Data;
		}

		return [];
	},

	updateOptions: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: OptionAPI.getAPIUrl() + '/update',
				data: payload
			},
			true
		);

		if (res.Success) {
			return res.Data;
		}

		return true;
	}
};
